//@flow
import ProductsStoreClass from './productsStoreClass';
import QuoteStore from '../Quote';

export default new ProductsStoreClass({}, {
  QuoteStore,
});
